import Header from "../global/components/Header";
import Footer from '../global/components/Footer';
import ChpRouter from "./components/CphRouter";
import { CphProvider } from "./contexts/CphContext";
import { CphDataProvider } from "./contexts/CphDataContext";
import { AuthenticationProvider } from "../global/contexts/AuthenticationContext";
import { AuthorizationProvider } from "../global/contexts/AuthorizationContext";
import { UserInfoProvider } from "../global/contexts/UserInfoContext";

//This component sets up the Cph application.
export default function CphApp() {
    return (
        <>
            <Header message={"Coding and Payment Hotline"} />
            <AuthenticationProvider>
                <AuthorizationProvider>
                    <UserInfoProvider>
                        <CphProvider>
                            <CphDataProvider>
                                <ChpRouter />
                            </CphDataProvider>
                        </CphProvider>
                    </UserInfoProvider>
                </AuthorizationProvider>
            </AuthenticationProvider>
            <Footer />
        </>
    );
}
